import React, { useState, useEffect } from 'react';
import { Grid, TextField, IconButton, Button } from '@material-ui/core';
import TableCollapsible from '../../Tables/TableColapseNoPaginationDoacao';
import api from '@http/api';
import { CurrencyFormat, FormatDate } from '@utils/formats';
import { getColors } from '@styles/colorsTheme';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone'
import ExpandLessTwoToneIcon from '@mui/icons-material/ExpandLessTwoTone'
import InvisibleContent from '@components/Shared/InvisibleContent';
import Services, { IModelo } from './services';
import { useSnackbar } from 'notistack';
import ButtonComponent from '@components/Shared/Buttons/Button';
import Modal from '@src/components/Shared/Modal/ModalPure';
import Extrato from '@components/Shared/Perfil/TabelaDoacao/extrato';

interface IProps {
  idPerfil: number;
  idPessoa: number;
}

const GetDoacoes: React.FC<IProps> = ({ idPerfil, idPessoa }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<IModelo[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [resumoDoacaoMedia, setResumoDoacaoMedia] = useState('');
  const [resumoDoacaoUltimaData, setResumoDoacaoUltimaData] = useState('');
  const [resumoDoacaoPrimeiraData, setResumoDoacaoPrimeiraData] = useState('');
  const [resumoDoacaoTotal, setResumoDoacaoTotal] = useState<number>(0);
  const [resumoPessoaNome, setResumoPessoaNome] = useState<string>('');
  const [resumoPessoaDocumento, setResumoPessoaDocumento] = useState<string>('');
  const { enqueueSnackbar } = useSnackbar();

  const [qntItemsPagina, setQntItemsPagina] = useState(5);
  const [pagina, setPagina] = useState(0);
  const [openModalExtrato, setOpenModalExtrato] =
    useState(false);

  const columnsLabel = {
    data_doacao: 'Data',
    origem_doacao_descricao: 'Origem',
    campanha_descricao: 'Campanha',
    valor_doacao: 'Valor',
    observacao: 'Observacao',
  };

  // Função para carregar doações
  async function loadData(page: number) {
    setLoading(true);
    try {
      const response = await api.post('api/Doacao/FindDoacoesByPerfil', { perfil_id: idPerfil })

      const items = response.data.doacoes || [];
      if (items.length > 0) {

        const itemData: IModelo[] = items.map((item: IModelo) => ({
          data_doacao: FormatDate(item.data_doacao),
          valor_doacao: CurrencyFormat(parseFloat(item.valor_doacao)),
          origem_doacao_descricao: item.origem_doacao_descricao,
          campanha_descricao: item.campanha_descricao,
          observacao: item.observacao || '',
          fundo_nome: item.fundo_nome || '',
          projeto_nome: item.projeto_nome || '',

        }));

        setData(itemData);
      } else {
        setData([]);
        enqueueSnackbar('Nenhuma doação encontrada para esta página.', {
          variant: 'info',
        });
      }
    } catch (error) {
      console.error('Erro ao carregar doações:', error);
      enqueueSnackbar('Ocorreu um erro ao carregar as doações: ' + (error instanceof Error ? error.message : 'Erro desconhecido'), {
        variant: 'error',
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadData(pagina);
  }, [pagina]);



    // Carregar resumos de doações e perfil
    useEffect(() => {
      const loadResumoDoacoes = async () => {
        const services = new Services();
        const { error, response } = await services.getResumoDoacao({ idPerfil });
        if (!error && response) {
          setResumoDoacaoMedia(response.media_doacoes);
          setResumoDoacaoPrimeiraData(FormatDate(response.primeira_doacao));
          setResumoDoacaoUltimaData(FormatDate(response.ultima_doacao));
          setResumoDoacaoTotal(response.total_doacoes);
        }
      };

      const loadResumoPerfil = async () => {
        const services = new Services();
        const { error, response } = await services.getPessoa({ idPessoa });
        if (!error && response) {
          setResumoPessoaNome(response.nome);
          setResumoPessoaDocumento(response.documento);
        }
      };

      loadResumoDoacoes();
      loadResumoPerfil();
    }, [idPerfil, idPessoa]);


    const formatDocument = (value: string) => {
      // Remove tudo que não for número
      value = value.replace(/\D/g, '');

      if (value.length <= 11) {
        // Máscara de CPF
        return value
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      } else {
        // Máscara de CNPJ
        return value
          .replace(/(\d{2})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d)/, '$1/$2')
          .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
      }
    };



  const handleNextPage = () => {
    setPagina((prevPagina) => prevPagina + 1);
  };

  const handlePrevPage = () => {
    if (pagina > 0) setPagina((prevPagina) => prevPagina - 1);
  };

  const filteredData = data.filter((item) =>
    item.observacao.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>

<Modal
        title="Extrato"
        size="pequeno"
        openModal={openModalExtrato}
        controlModal={(value: boolean) => setOpenModalExtrato(value)}
      >

<Extrato
          perfil_id={idPerfil}

        />

      </Modal>

<Grid
        container
        style={{
          paddingRight: 10,
          paddingLeft: 10,
          marginTop: 0,
          marginBottom: 0,
        }}
        justify="center"
        alignItems="center"
      >
          <Grid container justify="center" alignItems="center">
            <Grid item sm={6} xs={12}>
              <Grid container>
              <Grid item xs={12}>
            </Grid>
                <Grid item md={12}>
                  <p style={{ color: '#616161' }}>
                    Média doação:{' '}
                      <strong>
                        {CurrencyFormat(
                          parseFloat(resumoDoacaoMedia),
                        )}{' '}
                      </strong>
                  </p>
                </Grid>

                <Grid item md={12}>
                  <p style={{ color: '#616161' }}>
                    Total doação:{' '}
                      <strong>
                        {resumoDoacaoTotal}
                      </strong>
                  </p>
                </Grid>
              </Grid>
            </Grid>

            <Grid item sm={6} xs={12}>
              <Grid container>
                <Grid item md={12}>
                  <p style={{ color: '#616161' }}>
                    Primeira doação em:{' '}
                      <strong>
                        {(
                          resumoDoacaoPrimeiraData
                          ) === '01/01/0001'
                          ? '--/--/----'
                          : (
                            resumoDoacaoPrimeiraData
                        )}
                      </strong>
                  </p>
                </Grid>

                <Grid item md={12}>
                  <p style={{ color: '#616161' }}>
                    Última doação em:{' '}
                      <strong>
                        {(
                          resumoDoacaoUltimaData
                          ) === '01/01/0001'
                          ? '--/--/----'
                          : (
                          resumoDoacaoUltimaData
                        )}
                      </strong>
                  </p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
      </Grid>

      <Grid item sm={12} xs={12} style={{ paddingTop: 10 }}>
        <ButtonComponent
          color="primary"
          onClick={() => setOpenModalExtrato(true)}
          loading={loading}
        >
          Gerar extrato
        </ButtonComponent>
      </Grid>

      <Grid container>
        <TextField
          label="Pesquisar"
          variant="outlined"
          margin="normal"
          style={{ width: '100%' }}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </Grid>

      <TableCollapsible
        loading={loading}
        columns={[columnsLabel]}
        data={filteredData}
        keys={['Data', 'valor', 'Origem', 'Campanha', 'Detalhes']}

        />

        <Grid></Grid>


    </>
  );
};

export default GetDoacoes;
